// Test IDs for the Catherine Magawa portfolio.
export const NAV = {
  root: 'nav-root',
  logo: 'nav-logo',
  linkHome: 'nav-link-home',
  linkAbout: 'nav-link-about',
  linkExperience: 'nav-link-experience',
  linkResearch: 'nav-link-research',
  linkSkills: 'nav-link-skills',
  linkWriting: 'nav-link-writing',
  linkFaq: 'nav-link-faq',
  linkContact: 'nav-link-contact',
  downloadCv: 'nav-download-cv',
  menuToggle: 'nav-menu-toggle',
};

export const ADMIN = {
  form: 'admin-login-form',
  token: 'admin-token-input',
  submit: 'admin-unlock-submit',
  list: 'admin-message-list',
  readToggle: 'admin-read-toggle',
  filter: 'admin-filter',
  replyBtn: 'admin-reply-btn',
  replyInput: 'admin-reply-input',
  replySend: 'admin-reply-send',
};

export const HERO = {
  root: 'hero-root',
  emailCta: 'hero-email-cta',
  viewWork: 'hero-view-work',
  portrait: 'hero-portrait',
};

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-input-name',
  email: 'contact-input-email',
  subject: 'contact-input-subject',
  message: 'contact-input-message',
  submit: 'contact-submit',
  downloadCv: 'contact-download-cv',
  downloadRefs: 'contact-download-refs',
};
